import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { CustomFieldCell } from '../CustomFieldCell';
import { ContentTypeFieldResponse } from '@cs-cms/types';
import { RemoveCell } from '../../../grid/customCells/RemoveCell';

enum GridFileFields {
  METADATA_PREFIX = 'perFileMetadata.'
}

export const NameCell = (props: GridCellProps) => {
  const dataItem = props.dataItem;
  const file = dataItem?.file || dataItem;
  return <td title={file?.name}>{file?.name}</td>;
};

interface CellHandlers {
  getFieldChoices: (field: any) => any[];
  perFileFields: ContentTypeFieldResponse[];
  handleRemove: (fileIndex: number) => void;
}

export const createRemoveCellWrapper = (handlersRef: React.RefObject<CellHandlers>) => {
  return (props: GridCellProps) => {
    return (
      <RemoveCell
        dataItem={props.dataItem}
        field={props.field}
        dataIndex={props.dataIndex}
        id={props.id}
        columnPosition={props.columnPosition}
        onChange={props.onChange}
        className={props.className}
        colSpan={props.colSpan}
        ariaColumnIndex={props.ariaColumnIndex}
        isSelected={props.isSelected}
        style={props.style}
        rowType={props.rowType}
        level={props.level}
        expanded={props.expanded}
        onClick={() => handlersRef.current.handleRemove(props.dataIndex)}
      />
    );
  };
};

export const createCustomFieldCellWrapper = (handlersRef: React.RefObject<CellHandlers>) => {
  return (props: GridCellProps) => {
    const { field } = props;

    if (!field || !field.startsWith(GridFileFields.METADATA_PREFIX)) {
      return <td />;
    }

    const fieldName = field.replace(GridFileFields.METADATA_PREFIX, '');
    const ctField = handlersRef.current.perFileFields.find(f => f.name === fieldName);

    if (!ctField) {
      return <td>Field not found</td>;
    }

    return (
      <td>
        <CustomFieldCell
          dataItem={props.dataItem}
          field={props.field}
          dataIndex={props.dataIndex}
          id={props.id}
          columnPosition={props.columnPosition}
          onChange={props.onChange}
          className={props.className}
          colSpan={props.colSpan}
          ariaColumnIndex={props.ariaColumnIndex}
          isSelected={props.isSelected}
          style={props.style}
          rowType={props.rowType}
          level={props.level}
          expanded={props.expanded}
          ctField={ctField}
          getFieldChoices={handlersRef.current.getFieldChoices}
        />
      </td>
    );
  };
};
